import { getField, updateField } from 'vuex-map-fields';

const getters = {
    getField,

    productDescription(state) {
        const description = Object.get(state.product, 'site_product_attributes.0.meta.description', '');
        return typeof description === 'string' ? description.replace(/\n/g, '') : description;
    },

    productShortDescription(state) {
        return Object.get(state.product, 'site_product_attributes.0.meta.short_description', '');
    },

    casePack(state) {
        return Object.get(state.selectedProduct, 'site_product_attributes.0.meta.case_pack', '');
    },

    selectedProduct(state) {
        return state.selectedProduct
    },

    selectedProductCustomizationType(state) {
        return Object.get(state.selectedProduct, 'site_product_attributes.0.meta.bottle_customization_type', '');
    },

    inCustomization(state) {
        return state.inCustomization
    },

    orderQty(state) {
        return state.orderQty
    },

    minQty(state) {
        return Object.get(state.selectedProduct, 'site_product_attributes.0.meta.min_order', '1');
    },

    stockQty(state) {
        return parseInt(Object.get(state.selectedProduct, 'site_product_attributes.0.stock_qty', ''));
    },

    canvasOutputBlobImageURL(state) {
        if (!state.canvasOutputBlob) {
            return '';
        }
        return URL.createObjectURL(state.canvasOutputBlob)
    }
};

const state = {
    product: {},
    selectedProduct: {},
    customize: false,
    is_laser_engraved: 0,
    inCustomization: false,
    orderQty: 0,
    canvasOutputBlob: '',
    customizer_logo_id: '',
    selectedPantones: [],
    customization_type: '',
    customer_customizer_notes: '',
    customizer_stepper: 1,
    customerNotes: null,
};

const mutations = {
    updateField,

    setProduct(state, product) {
       state.product = product
    },
    setSelectedProduct(state, product) {
       state.selectedProduct = product
    },
    setInCustomization(state, newState) {
        state.inCustomization = newState
    },
    setIsLaserEngraved(state, type) {
        state.is_laser_engraved = type
    },
    setProductQty(state, qty) {
        state.orderQty = qty ? qty : 0;
    },
    setCustomizeStatus(state, status) {
        state.customize = status;
    },
    setCanvasOutputBlob(state, data) {
        state.canvasOutputBlob = data;
    },
    setSelectedPantones(state, data) {
        state.selectedPantones = data;
    },
    setCustomizerLogoId(state, id) {
        state.customizer_logo_id = id;
    },
    setCustomizationType(state, type) {
        state.customization_type = type
    }
};

const actions = {
    setSelectedProduct({commit, state}, product) {
        commit('setSelectedProduct', product);
        state.canvasOutputBlob = null;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};